/* ============================================================
   WAGGY WAYS COZYPAWS — interactions
   gallery · accordions/FAQ · color/qty · sticky bar · cart drawer
   ============================================================ */
document.addEventListener('DOMContentLoaded', function () {
  "use strict";

  var PRICE = 129.95;
  var FREE_SHIP_THRESHOLD = 150;

  /* ---------- helpers ---------- */
  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function money(n) { return "$" + n.toFixed(2); }

  /* ============================================================
     GALLERY — thumbnail switching + flip control
     ============================================================ */
  var galleryImg = $("#galleryImg");
  var flipLabel  = $("#flipLabel");
  var flipBtn    = $("#flipBtn");

  /* Derive SIDE_A and SIDE_B from the first two cp-thumb buttons
     so the src values are always the real Shopify CDN URLs,
     not hard-coded paths that don't exist in production. */
  var thumbs = $all(".cp-thumb");
  var SIDE_A = thumbs[0] ? { src: thumbs[0].getAttribute("data-src"), label: thumbs[0].getAttribute("data-side") } : null;
  var SIDE_B = thumbs[1] ? { src: thumbs[1].getAttribute("data-src"), label: thumbs[1].getAttribute("data-side") } : null;

  function swapMain(src, sideLabel) {
    if (!galleryImg) return;
    galleryImg.style.opacity = "0";
    galleryImg.style.transform = "scale(0.97)";
    setTimeout(function () {
      galleryImg.src = src;
      galleryImg.style.opacity = "1";
      galleryImg.style.transform = "scale(1)";
    }, 180);
    if (flipLabel && sideLabel) {
      flipLabel.innerHTML = "Showing: <b>" + sideLabel + "</b>";
    }
  }

  function syncThumb(src) {
    $all(".cp-thumb").forEach(function (t) {
      t.classList.toggle("active", t.getAttribute("data-src") === src);
    });
  }

  // wire up transition styles inline so no CSS change is needed
  if (galleryImg) {
    galleryImg.style.transition = "opacity 0.18s ease, transform 0.18s ease";
  }

  $all(".cp-thumb").forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      var src  = thumb.getAttribute("data-src");
      var side = thumb.getAttribute("data-side");
      syncThumb(src);
      swapMain(src, side);
      if (flipBtn && SIDE_B) {
        flipBtn.classList.toggle("flipped", src === SIDE_B.src);
      }
    });
  });

  // flip toggles between the two reversible sides
  if (flipBtn && SIDE_A && SIDE_B) {
    flipBtn.addEventListener("click", function () {
      var toB = !flipBtn.classList.contains("flipped");
      flipBtn.classList.toggle("flipped", toB);
      var next = toB ? SIDE_B : SIDE_A;
      swapMain(next.src, next.label);
      syncThumb(next.src);
    });
  }

  /* ============================================================
     QUANTITY STEPPER (buy box)
     ============================================================ */
  var qty    = 1;
  var qtyVal = $("#qtyVal");
  function setQty(n) {
    qty = Math.max(1, Math.min(20, n));
    if (qtyVal) qtyVal.textContent = qty;
  }
  $("#qtyMinus") && $("#qtyMinus").addEventListener("click", function () { setQty(qty - 1); });
  $("#qtyPlus")  && $("#qtyPlus").addEventListener("click",  function () { setQty(qty + 1); });

  /* ============================================================
     ACCORDIONS (FAQ)
     ============================================================ */
  $all(".acc-head").forEach(function (head) {
    head.addEventListener("click", function () {
      var item   = head.closest(".acc-item");
      var body   = item.querySelector(".acc-body");
      var isOpen = item.classList.contains("open");
      var group  = head.closest(".acc");
      if (group) {
        $all(".acc-item.open", group).forEach(function (other) {
          if (other !== item) {
            other.classList.remove("open");
            other.querySelector(".acc-body").style.maxHeight = null;
          }
        });
      }
      if (isOpen) {
        item.classList.remove("open");
        body.style.maxHeight = null;
      } else {
        item.classList.add("open");
        body.style.maxHeight = body.scrollHeight + "px";
      }
    });
  });

  /* ============================================================
     STICKY ADD-TO-BAR
     ============================================================ */
  var stickyBar = $("#stickyBar");
  var buyBox    = $("#buyBox");
  if (stickyBar && buyBox && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
          stickyBar.classList.add("show");
        } else {
          stickyBar.classList.remove("show");
        }
      });
    }, { threshold: 0, rootMargin: "-80px 0px 0px 0px" });
    io.observe(buyBox);
  }
});